// Language utility for multilingual support
const translations = {
  en: {
    android: {
      title: 'Android App',
      subtitle: 'Coming Soon',
      description: 'Be the first to know when our Android app launches. Join the waitlist and we\'ll notify you as soon as it\'s available.',
      firstNamePlaceholder: 'First Name (Optional)',
      lastNamePlaceholder: 'Last Name (Optional)',
      emailPlaceholder: 'Enter your email',
      submitButton: 'Join Waitlist',
      submitting: 'Joining...',
      successMessage: 'Thank you for joining! We\'ll notify you when the Android app is ready.',
      errorInvalidEmail: 'Please enter a valid email address',
      errorRateLimit: 'Too many attempts. Please try again later.',
      errorGeneric: 'Something went wrong. Please try again.'
    },
    monthlyPromo: {
      title: 'Congrats!',
      subtitle: 'You got a free month of Kewaar premium',
      description: 'Please enter your email and you\'ll get an email within the next 7 days.',
      firstNamePlaceholder: 'First Name (Optional)',
      lastNamePlaceholder: 'Last Name (Optional)',
      emailPlaceholder: 'Enter your email',
      submitButton: 'Join Promo',
      submitting: 'Joining...',
      successMessage: 'Thank you for joining! You\'ll receive our monthly promo offers soon.',
      errorInvalidEmail: 'Please enter a valid email address',
      errorRateLimit: 'Too many attempts. Please try again later.',
      errorGeneric: 'Something went wrong. Please try again.'
    }
  },
  ar: {
    android: {
      title: 'تطبيق أندرويد',
      subtitle: 'قريباً',
      description: 'كن أول من يعرف عندما نطلق تطبيق أندرويد. انضم إلى قائمة الانتظار وسنخطرك بمجرد توفره.',
      firstNamePlaceholder: 'الاسم الأول (اختياري)',
      lastNamePlaceholder: 'اسم العائلة (اختياري)',
      emailPlaceholder: 'أدخل بريدك الإلكتروني',
      submitButton: 'انضم إلى قائمة الانتظار',
      submitting: 'جاري الانضمام...',
      successMessage: 'شكراً لانضمامك! سنخطرك عندما يكون تطبيق أندرويد جاهزاً.',
      errorInvalidEmail: 'الرجاء إدخال بريد إلكتروني صحيح',
      errorRateLimit: 'محاولات كثيرة جداً. الرجاء المحاولة لاحقاً.',
      errorGeneric: 'حدث خطأ ما. الرجاء المحاولة مرة أخرى.'
    },
    monthlyPromo: {
      title: 'تهانينا!',
      subtitle: 'لقد حصلت على شهر مجاني من كيوار بريميوم',
      description: 'الرجاء إدخال بريدك الإلكتروني وستصلك رسالة خلال الأيام السبعة القادمة.',
      firstNamePlaceholder: 'الاسم الأول (اختياري)',
      lastNamePlaceholder: 'اسم العائلة (اختياري)',
      emailPlaceholder: 'أدخل بريدك الإلكتروني',
      submitButton: 'انضم إلى العرض',
      submitting: 'جاري الانضمام...',
      successMessage: 'شكراً لانضمامك! ستصلك عروضنا الشهرية قريباً.',
      errorInvalidEmail: 'الرجاء إدخال بريد إلكتروني صحيح',
      errorRateLimit: 'محاولات كثيرة جداً. الرجاء المحاولة لاحقاً.',
      errorGeneric: 'حدث خطأ ما. الرجاء المحاولة مرة أخرى.'
    }
  }
}

// Detect language from device/browser
export function detectLanguage() {
  // Check if we're in a browser environment
  if (typeof navigator === 'undefined') {
    return 'en'
  }
  
  // Get browser language
  const browserLang = navigator.language || navigator.userLanguage || 'en'
  
  // Check if it's Arabic
  if (browserLang.toLowerCase().startsWith('ar')) {
    return 'ar'
  }
  
  // Default to English
  return 'en'
}

// Get translations for a specific page and language
export function getTranslations(page, lang = null) {
  const language = lang || detectLanguage()
  return translations[language]?.[page] || translations.en[page]
}

// Vue mixin for easy integration
export const i18nMixin = {
  data() {
    return {
      currentLang: detectLanguage()
    }
  },
  computed: {
    isRTL() {
      return this.currentLang === 'ar'
    },
    toggleLangLabel() {
      return this.currentLang === 'ar' ? 'English' : 'العربية'
    }
  },
  methods: {
    t(page, key) {
      const translations = getTranslations(page, this.currentLang)
      return translations[key] || key
    },
    setLanguage(lang) {
      this.currentLang = lang
      // Update document direction
      if (typeof document !== 'undefined') {
        document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr'
        document.documentElement.lang = lang
      }
    },
    toggleLanguage() {
      const newLang = this.currentLang === 'ar' ? 'en' : 'ar'
      this.setLanguage(newLang)
    }
  },
  mounted() {
    // Set initial direction
    if (typeof document !== 'undefined') {
      document.documentElement.dir = this.isRTL ? 'rtl' : 'ltr'
      document.documentElement.lang = this.currentLang
    }
  }
}

export default {
  detectLanguage,
  getTranslations,
  i18nMixin
}
